import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';
import { _levelPoints, _collectionTimer } from 'src/_mock/benefits/_collectibles';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class CollectiblesRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getCollectiblesList(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.list,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCollectionTimer(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.collectionTimer,
      params,
    };

    const options: HttpTypes.RequestOptions = {
      data: _collectionTimer,
      status: 200,
      delay: 2000,
    };

    const response = await this.api.fakeRequest(request, options);

    return httpResponseHandler(response);
  }

  async unlockItem(body: {
    id: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.collectibles.unlockItem,
      body,
    };

    const options: HttpTypes.RequestOptions = {
      data: { message: 'Collectible created successfully' },
      status: 200,
      delay: 2000,
    };

    const response = await this.api.fakeRequest(request, options);

    return httpResponseHandler(response);
  }

  async getCollectibleDetails(
    collectibleId: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.collectibleDetails,
      params: { collectibleId },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async rescueCollectible(body: {
    collectibleId: string;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.collectibles.rescueCollectible,
      body,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getLevelPoints(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.levelPoints,
      params,
    };

    const options: HttpTypes.RequestOptions = {
      data: _levelPoints,
      status: 200,
      delay: 2000,
    };

    const response = await this.api.fakeRequest(request, options);

    return httpResponseHandler(response);
  }

  async getNewUnlockedItems(
    collectionId: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.newUnlockedItems,
      params: { collectionId },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async verifyActiveCollection(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.verifyActiveCollection,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getCollectibleRedemptionDetails(
    collectibleRedemptionId: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.collectibles.collectibleRedemptionDetails(collectibleRedemptionId),
    };
    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
